export const StatusOperationBC = [
  {
    label: 'None',
    id: 0,
  },
  {
    label: 'Open'.toUpperCase(),
    id: 1,
    color: 'success',
    hex: '#2e7d32',
  },
  {
    label: 'Closed'.toUpperCase(),
    id: 2,
    color: 'error',
    hex: '#d32f2f',
  },
];

export const StatusOperationBF = [
  {
    label: 'None',
    id: 0,
  },
  {
    label: 'Open'.toUpperCase(),
    id: 1,
    color: 'success',
    hex: '#2e7d32',
  },
  {
    label: 'Closed'.toUpperCase(),
    id: 2,
    color: 'error',
    hex: '#d32f2f',
  },
];

export const AccountType = [
  {
    id: 'None',
    label: 'None',
  },
  {
    id: 'CHARTER',
    label: 'CHARTER',
  },
  {
    id: 'BOAT',
    label: 'BOAT',
  },
];

export const StatusOperationType = [
  {
    id: 'None',
    label: 'None',
  },
  {
    id: 'OPEN',
    label: 'OPEN',
  },
  {
    id: 'CLOSED',
    label: 'CLOSED',
  },
];

export const StatusOperationBookingType = [
  {
    id: 'NEW REQUEST',
    label: 'NEW REQUEST',
    color: '#fff',
    backgroundColor: '#005488',
  },
  {
    id: 'STAND-BY',
    label: 'STAND-BY',
    color: '#fff',
    backgroundColor: '#ff6500',
  },
  {
    id: 'IN PROGRESS',
    label: 'IN PROGRESS',
    color: '#fff',
    backgroundColor: '#f6ca00',
  },
  {
    id: 'CONFIRMED',
    label: 'CONFIRMED',
    color: '#fff',
    backgroundColor: '#00c256',
  },
  {
    id: 'COMPLETED',
    label: 'COMPLETED',
    color: '#fff',
    backgroundColor: '#008c40',
  },
  // {
  //   id: 'READY TO INVOICE',
  //   label: 'READY TO INVOICE',
  //   color: '#fff',
  //   backgroundColor: '#0d9488',
  // },
  // {
  //   id: 'INVOICED',
  //   label: 'INVOICED',
  //   color: '#fff',
  //   backgroundColor: '#0f766e',
  // },
  {
    id: 'DECLINED',
    label: 'DECLINED',
    color: '#fff',
    backgroundColor: '#e74c3c',
  },
  {
    id: 'CANCELLED',
    label: 'CANCELLED',
    color: '#fff',
    backgroundColor: '#ff001b',
  },
];

export const DEFAULT_STATUS_OPERATION_BOOKING = [
  {
    label: 'NEW REQUEST',
    id: 'NEW REQUEST',
  },
  {
    label: 'STAND-BY',
    id: 'STAND-BY',
  },
  {
    id: 'IN PROGRESS',
    label: 'IN PROGRESS',
  },
  {
    id: 'CONFIRMED',
    label: 'CONFIRMED',
  },
];

export const DataConf = {
  initialState: {
    loading: false,
    error: null,
    data: [],
    meta: null,
  },
};

export const NewStatus = [
  {
    id: 'NEW REQUEST',
    label: 'NEW REQUEST',
    color: '#fff',
    backgroundColor: '#005488',
  },
  {
    id: 'STAND-BY',
    label: 'STAND-BY',
    color: '#fff',
    backgroundColor: '#ff6500',
  },
  {
    id: 'IN PROGRESS',
    label: 'IN PROGRESS',
    color: '#fff',
    backgroundColor: '#f6ca00',
  },
  {
    id: 'CONFIRMED',
    label: 'CONFIRMED',
    color: '#fff',
    backgroundColor: '#00c256',
  },
  {
    id: 'COMPLETED',
    label: 'COMPLETED',
    color: '#fff',
    backgroundColor: '#008c40',
  },
  // {
  //   id: 'READY TO INVOICE',
  //   label: 'READY TO INVOICE',
  //   color: '#fff',
  //   backgroundColor: '#0d9488',
  // },
  // {
  //   id: 'INVOICED',
  //   label: 'INVOICED',
  //   color: '#fff',
  //   backgroundColor: '#0f766e',
  // },
  {
    id: 'DECLINED',
    label: 'DECLINED',
    color: '#fff',
    backgroundColor: '#e74c3c',
  },
  {
    id: 'CANCELLED',
    label: 'CANCELLED',
    color: '#fff',
    backgroundColor: '#ff001b',
  },
];

export const DefaultStatusOpBooking = StatusOperationBookingType?.filter(
  (item) =>
    item?.id === 'NEW REQUEST' ||
    item?.id === 'STAND-BY' ||
    item?.id === 'IN PROGRESS' ||
    item?.id === 'CONFIRMED' ||
    item?.id === 'COMPLETED' ||
    item?.id === 'CANCELLED'
);

export const ContactType = [
  {
    id: 'EMAIL',
    label: 'EMAIL',
  },
  {
    id: 'WHATSAPP',
    label: 'WHATSAPP',
  },
  {
    id: 'SHOP',
    label: 'SHOP',
  },
];

export const BooleanOptions = [
  { label: 'ENABLE', id: true },
  { label: 'DISABLE', id: false },
];

export const AreaOptions = [
  {
    id: null,
    label: 'NONE'
  },
  {
    id: 'NORD',
    label: 'NORTH'
  },
  {
    id: 'SUD',
    label: 'SOUTH'
  },
  {
    id: 'CARIBBEAN',
    label: 'CARIBBEAN'
  },
];

export const DefaultAreas = AreaOptions?.filter(
  (item) =>
    item?.id === null ||
    item?.id === 'NORD' ||
    item?.id === 'SUD'
);


export const StatusBilling = [
  {
    id: 'PENDING',
    label: 'PENDING',
    color: '#fff',
    backgroundColor: '#FF6500',
    hex: '#FF6500',
    textHex: '#fff',
  },
  {
    id: 'READY TO INVOICE',
    label: 'READY TO INVOICE',
    color: '#fff',
    backgroundColor: '#0891B2',
    hex: '#0891B2',
    textHex: '#fff',
  },
  {
    id: 'INVOICED',
    label: 'INVOICED',
    color: '#fff',
    backgroundColor: '#008c40',
    hex: '#008c40',
    textHex: '#fff',
  },
  {
    id: 'ON HOLD',
    label: 'ON HOLD',
    color: '#fff',
    backgroundColor: '#DC2626',
    hex: '#DC2626',
    textHex: '#fff',
  },
  {
    id: 'NOT BILLABLE',
    label: 'NOT BILLABLE',
    color: '#fff',
    backgroundColor: '#7C3AED',
    hex: '#7C3AED',
    textHex: '#fff',
  },
  {
    id: 'WRITE OFF',
    label: 'WRITE OFF',
    color: '#fff',
    backgroundColor: '#6B7280',
    hex: '#6B7280',
    textHex: '#fff',
  },
];

export const DefaultStatusBilling = StatusBilling?.filter(
  (item) =>
    item?.id === 'PENDING' ||
    item?.id === 'READY TO INVOICE' ||
    item?.id === 'ON HOLD'
);